<template lang="pug">
    div
        #print
            .body(v-if="printData && printData.length" v-for="data in printData")
                .header
                    //.elem
                      label № Заявки
                      #deal-tracking-number(v-if="data.deal_tracking") {{data.deal_tracking}}
                    .elem.left
                      label №
                      .freight-tracking-number(v-if="data.freight_tracking") {{data.freight_tracking}}
                    .elem.right(v-if="data.seat_number")
                        label {{data.seat_number + ' из ' + data.seats_number}}
                .content
                    .text
                        .date.text-item(v-if="data.created_at")
                            div Дата приёма:
                            b {{data.created_at}}

                        .from.text-item(v-if="data.from_city")
                            div Отправление:
                            b {{data.from_city}}

                        .to.text-item(v-if="data.to_city")
                            div Назначение:
                            b {{data.to_city}}

                        .to.text-item(v-if="data.recipient")
                            div Получатель:
                            b {{ mb_strimwidth(data.recipient, 0, 50, '...') }}

                        .regime.text-item(v-if="data.temperatureRegime")
                            b Т
                    .qr
                        canvas(v-bind:ref="data.ref")
</template>
<script>
    import QRCode from "qrcode";
    export default {
        components: {QRCode},
        data() {
            return {
                data: {},
                printData: []
            }
        },
        watch: {},
        computed: {
            print() {
                return this.$store.state.print;
            }
        },
        methods: {
            init() {
                this.data = JSON.parse(this.$route.query.data);
                this.printData = [];
                for (let i = this.data.from; i <= this.data.to; i++) {
                    this.printData.push({
                        seat_number:       i,
                        seats_number:      this.data.seats_number,
                        ref:               ('ticket-' + i),
                        created_at:        this.data.created_at,
                        deal_tracking:     this.data.deal_tracking,
                        freight_tracking:  (this.data.freight_tracking + '/' + i),
                        //freight_tracking: this.data.freight_tracking,
                        from_city:         this.data.from_city,
                        to_city:           this.data.to_city,
                        recipient:         this.data.recipient,
                        sender:            this.data.sender,
                        temperatureRegime: this.data.temperatureRegime,
                    });
                }

                this.$nextTick(() => {
                    let hasError = false;
                    this.printData.map(item => {
                        if (this.$refs[item.ref] && this.$refs[item.ref][0])
                            QRCode.toCanvas(this.$refs[item.ref][0], item.freight_tracking, (error) => {
                                if (error) {
                                    hasError = true;
                                    alert('Возникла ошибка при печати: ' + error);
                                }
                            });
                    });
                    if (!hasError) setTimeout(() => {
                        this.closePageListener();
                        window.print();    
                    }, 500);
                });

            },
            /**
             * Функция слушает нажатие кнопок "Отмена" и "Печать"
             * на форме печати браузера, и если нажали "Отмена", закрывает страницу
             */
            closePageListener() {
                if (window.matchMedia) window.matchMedia('print').addListener(mql => {
                    if (!mql.matches) window.close();
                });
            },
            mb_strimwidth(...props) {
                return window.mb_strimwidth(...props)
            }
        },
        created() {
            if (!this.print) this.$store.commit('setPrint', true);
            else this.init();
        }
    }
</script>
<style lang="sass" src="./FreightTicketPrint.sass"></style>



// WEBPACK FOOTER //
// FreightTicketPrint.vue?9e2479ea